import React from 'react';
import './timeLineChart.css';
import { TimeLineButtonProps } from '../lifeCalenderInterFace';


const TimelineScrollButton = ({ canScrollLeft, canScrollRight, scrollLeftRight }: TimeLineButtonProps) => {

    return (
        <>
            <button
                onClick={() => scrollLeftRight('left')}
                disabled={!canScrollLeft}
                className='lineCalendarScrollButton'
                style={{
                    left: '10px',
                    background: canScrollLeft ? '#BB367A' : '#d1d5db',
                    cursor: canScrollLeft ? 'pointer' : 'not-allowed',
                }}
            >
                <span style={{ color: canScrollLeft ? 'white' : '#9ca3af' }} >{'<'}</span>
            </button>

            <button
                onClick={() => scrollLeftRight('right')}
                disabled={!canScrollRight}
                className='lineCalendarScrollButton'
                style={{
                    right: '10px',
                    background: canScrollRight ? '#BB367A' : '#d1d5db',
                    cursor: canScrollRight ? 'pointer' : 'not-allowed',
                }}
            >
                <span style={{ color: canScrollRight ? 'white' : '#9ca3af' }} >{'>'}</span>
            </button>
        </>
    );
};

export default TimelineScrollButton;